import PropTypes from 'prop-types';

const imageShape = PropTypes.shape({
  position: PropTypes.objectOf(PropTypes.string),
  src: PropTypes.string,
});

export default PropTypes.oneOfType([imageShape, PropTypes.string]);
